import { MeApiMeUpdateRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useMeUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: MeApiMeUpdateRequest, config) =>
      appApiClient.meApi.meUpdate(req, config),
  })
